import { isString } from 'lodash'

export default (value, length, { tail = '...' } = {}) => {
  if (!isString(value)) return ''
  if (value.length <= length) return value
  return value.substring(0, length) + tail
}
